module.exports = __webpack_public_path__ + "static/media/mountain-bike.34b74c2a.jpg";